export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "thrusterDownload.worker.d3a77deecc61e822dcaa-116.worker.js");
}
